import { useEffect, useState } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import Laoder from "../../Loader";
import doSearch from "./functions/doSearch";

function PreviousAdress({ close, set }) {
  const [isLoading, setIsLoading] = useState(false);
  const [query, setQuery] = useState("");
  const [items, setItems] = useState([]);

  useEffect(() => {
    const timeOutId = setTimeout(() => {
      doSearch(
        query,
        value => setIsLoading(value),
        data => setItems(data)
      );
    }, 1000);
    return () => clearTimeout(timeOutId);
  }, [query]);

  return (
    <Modal onHide={close} show={true} direction="rtl">
      <Modal.Header className="d-flex align-item-center justify-content-center">
        <Modal.Title>جستجو از آدرس های ثبت شده قبلی گیرنده</Modal.Title>
      </Modal.Header>
      <Modal.Body
        className="d-flex align-item-center justify-content-center text-right "
        style={{ textAlign: "right", direction: "rtl" }}
      >
        <div className="w-100 mt-2">
          <Form.Label>جستجوی آدرس (حداقل چهار کاراکتر الزامی است)</Form.Label>
          <Form.Control
            type="text"
            autoFocus
            onChange={e => {
              if (e.target.value.length > 3) {
                setItems(() => []);
                setQuery(() => e.target.value);
              }
            }}
          />
          {isLoading && (
            <div className="w-100">
              <Laoder />
            </div>
          )}
          <div className="w-100">
            {items.map(item => (
              <button
                key={item.id}
                className="btn btn-light w-100 my-1"
                onClick={() => set(item)}
              >
                <span>
                  {item.name ? item.name + " " + item.family : item.compony}
                </span>
                <span>
                  -&nbsp;
                  {item.country_name.faName +
                    " (" +
                    item.country_name.enName +
                    ") "}
                </span>
                <span>
                  -&nbsp;
                  {item.address_external.fa_city_name +
                    " (" +
                    item.address_external.en_city_name +
                    ") - "}
                </span>
                <span>
                  {item.address + " (" + item.address_external.address + ")"}
                </span>
              </button>
            ))}
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer className="d-flex align-item-center justify-content-center">
        <Button className="btn-cancel-style" onClick={close}>
          بستن
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default PreviousAdress;
